(function () {
  function scriptTag(){ return document.querySelector('script[data-css*="anemoia-quickview"]'); }
  function injectCss(){
    var s=scriptTag(); var href=s&&s.getAttribute('data-css');
    if(href&&!document.querySelector('link[data-anemoia-qv]')){
      var l=document.createElement('link'); l.rel='stylesheet'; l.href=href; l.setAttribute('data-anemoia-qv',''); document.head.appendChild(l);
    }
  }
  function ensureDialog(){
    var d=document.getElementById('AnemoiaQuickview'); if(d) return d;
    d=document.createElement('dialog'); d.id='AnemoiaQuickview'; d.className='anemoia-qv'; d.setAttribute('aria-label','Quick view');
    d.innerHTML='<button class="anemoia-qv__close" type="button" aria-label="Close" data-qv-close>&#215;</button><div class="anemoia-qv__body" data-qv-body></div>';
    document.body.appendChild(d); return d;
  }
  function addTriggers(){
    document.querySelectorAll('#product-grid .card-wrapper:not([data-qv]), .product-card-wrapper:not([data-qv])').forEach(function(card){
      var link=card.querySelector('a[href*="/products/"]'); if(!link) return;
      var href=link.getAttribute('href');
      card.setAttribute('data-qv',''); card.classList.add('anemoia-qv-card');
      var inner=card.querySelector('.card__inner'); if(inner) inner.classList.add('anemoia-qv-lift');
      var media=card.querySelector('.card__media')||card;
      media.style.cursor='pointer';
      media.addEventListener('click',function(e){ if(e.target.closest&&e.target.closest('.anemoia-qv-trigger')) return; window.location.href=href; });
      var btn=document.createElement('button'); btn.type='button'; btn.className='anemoia-qv-trigger';
      btn.textContent='Quick view'; btn.setAttribute('data-qv-url', href);
      media.appendChild(btn);
    });
  }
  function closeQv(){ var dc=document.getElementById('AnemoiaQuickview'); if(dc){ dc.close?dc.close():dc.removeAttribute('open'); } }
  function wireForm(scope){
    var form=scope.querySelector('[data-qv-form]'); if(!form) return;
    form.addEventListener('submit',function(e){
      e.preventDefault();
      var btn=form.querySelector('button[type=submit]'); var orig=btn?btn.textContent:'';
      if(btn){ btn.disabled=true; btn.textContent='Adding…'; }

      // Add via AJAX and open the cart drawer over the page — no navigation to /cart.
      var cart=document.querySelector('cart-drawer')||document.querySelector('cart-notification');
      var root=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';
      var formData=new FormData(form);
      if(cart&&typeof cart.getSectionsToRender==='function'){
        formData.append('sections', cart.getSectionsToRender().map(function(s){return s.id;}).join(','));
        formData.append('sections_url', window.location.pathname);
      }
      fetch(root+'cart/add.js',{
        method:'POST',
        headers:{'X-Requested-With':'XMLHttpRequest','Accept':'application/javascript'},
        body:formData
      })
      .then(function(r){ return r.json(); })
      .then(function(response){
        if(response && response.status){
          // add error (e.g. sold out) — surface and re-enable
          if(btn){ btn.disabled=false; btn.textContent=orig||'Add to cart'; }
          var body=scope.querySelector('[data-qv-body]')||scope;
          var err=document.createElement('p'); err.className='anemoia-qv__err'; err.textContent=response.description||response.message||'Could not add this piece.';
          form.appendChild(err);
          return;
        }
        closeQv();
        if(cart&&typeof cart.renderContents==='function'){
          cart.renderContents(response);           // renderContents re-renders + opens the drawer
          // Dawn leaves the `is-empty` class on <cart-drawer> when adding from an empty cart, which
          // keeps the empty-state CSS and hides the just-added item. Clear it so the item shows.
          if(cart.classList) cart.classList.remove('is-empty');
        }
        else { window.location.href=root+'cart'; }
        if(btn){ btn.disabled=false; btn.textContent=orig||'Add to cart'; }
      })
      .catch(function(){ window.location.href=(root+'cart'); });
    });
  }
  function openQv(url){
    var d=ensureDialog(); var body=d.querySelector('[data-qv-body]');
    body.innerHTML='<div class="anemoia-qv__loading">Loading…</div>';
    if(d.showModal){ try{ d.showModal(); }catch(err){ d.setAttribute('open',''); } } else { d.setAttribute('open',''); }
    var u=url+(url.indexOf('?')>-1?'&':'?')+'view=quickview';
    var pv=new URLSearchParams(window.location.search).get('preview_theme_id');
    if(pv) u+='&preview_theme_id='+pv;
    fetch(u,{headers:{'X-Requested-With':'XMLHttpRequest'},credentials:'same-origin'}).then(function(r){return r.text();}).then(function(html){
      var doc=new DOMParser().parseFromString(html,'text/html');
      var c=doc.getElementById('AnemoiaQuickviewContent');
      if(c){ body.innerHTML=c.outerHTML; wireForm(body); }
      else { body.innerHTML='<div class="anemoia-qv__loading">Unable to load preview. <a href="'+url+'">Open product &rarr;</a></div>'; }
    }).catch(function(){ body.innerHTML='<div class="anemoia-qv__loading">Unable to load preview. <a href="'+url+'">Open product &rarr;</a></div>'; });
  }
  document.addEventListener('click',function(e){
    var t=e.target.closest&&e.target.closest('.anemoia-qv-trigger');
    if(t){ e.preventDefault(); e.stopPropagation(); openQv(t.getAttribute('data-qv-url')); return; }
    if(e.target.closest&&e.target.closest('[data-qv-close]')){ closeQv(); return; }
    var dl=document.getElementById('AnemoiaQuickview'); if(dl&&e.target===dl){ closeQv(); }
  }, true);
  function init(){ injectCss(); ensureDialog(); addTriggers();
    // Observe the STABLE container — Dawn replaces #product-grid's contents on every filter/sort, so
    // watching #ProductGridContainer (which persists) keeps quick-view on freshly-rendered products.
    var grid=document.getElementById('ProductGridContainer')||document.querySelector('.collection')||document.querySelector('main')||document.body;
    if(grid&&window.MutationObserver){ new MutationObserver(addTriggers).observe(grid,{childList:true,subtree:true}); }
  }
  if(document.readyState!=='loading') init(); else document.addEventListener('DOMContentLoaded',init);
  document.addEventListener('shopify:section:load',addTriggers);
})();
